import { render } from "./SurnameTree.vue?vue&type=template&id=19d1a9ec"
import script from "./SurnameTree.vue?vue&type=script&lang=js"
export * from "./SurnameTree.vue?vue&type=script&lang=js"

import "./SurnameTree.vue?vue&type=style&index=0&id=19d1a9ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__